import enviro from 'enviro';
export const CSAT = {
  adminClosedSettings: {
    QA: 482,
    PROD: 1263
  },
  userClosedSettings: {
    QA: 481,
    PROD: 1262
  }
};
//trying to make it const
const launchCSAT = csat => {
  if (window.hsFeedback) {
    window.hsFeedback.loadSurvey('CSAT', CSAT[csat][enviro.isProd() ? 'PROD' : 'QA']);
  }
};
export const useLaunchCSAT = () => {
  return launchCSAT;
};